import { useHistory } from 'react-router-dom';

import { Button, Tooltip } from '@cobliteam/ui/components';

import { Location } from '@cobliteam/common-types';

import { Analytics } from '@cobliteam/analytics';

import Icon from '@cobliteam/ui/icons';

const ClientAreaButton = () => {
  const history = useHistory();
  const handleClick = () => {
    Analytics.track('Navbar Client Area Button Clicked');
    history.push(Location.BUSINESS_MANAGER_HOME);
  };

  return (
    <Tooltip content='Área do cliente'>
      <Button variant='outlined' color='secondary' size='condensed' icon={<Icon name='square-arrow-out-up-right' />} onClick={handleClick} />
    </Tooltip>
  );
};

export default ClientAreaButton;
